export default __webpack_public_path__ + "static/media/logia.55df8781.jpg";